import styled from "styled-components";
import {
	FONT_WT_MEDIUM,
	COLOR_TEXT_PRIMARY_B2C,
	DESKTOP_SM_BP,
	MOBILE_L_BP,
	COLOR_TEXT_HIGHLIGHT,
	FONT_WT_LIGHT,
	COLOR_LIGHT_GREY_CYAN,
} from "@website-builder/utilities-index";

export const CardsContainer = styled.div`
	text-align: center;
	padding: 65px 180px 100px 180px;
	.slick-slider {
		.slick-next:before,
		.slick-prev:before {
			font-size: 36px !important;
			color: var(--primary-forest-600);
			-webkit-font-smoothing: auto;
		}
		.slick-prev {
			position: absolute;
			left: 50%;
			top: 110%;
			margin-left: -40px;
		}
		.slick-next {
			position: absolute;
			left: 50%;
			top: 110%;
			margin-left: 5px;
		}
	}
	.heading {
		font-size: 28px;
		font-weight: ${FONT_WT_MEDIUM};
		line-height: 1;
		color: ${COLOR_TEXT_PRIMARY_B2C};
		padding-bottom: 35px;
	}
	.content {
		font-size: 16px;
		font-weight: ${FONT_WT_LIGHT};
		line-height: 1.69;
		color: ${COLOR_TEXT_PRIMARY_B2C};
		padding: 0px 25px 50px 25px;
	}
	.cardWrapper {
		min-height: 320px;
		width: 300px;
		border-radius: 3px;
		box-shadow: 0 9px 20px 0 rgba(0, 0, 0, 0.05);
		.cardHeading {
			font-size: 20px;
			font-weight: ${FONT_WT_MEDIUM};
			line-height: 1.35;
			padding: 30px 20px 20px 20px;
			text-align: left;
		}
		.cardContent {
			font-size: 16px;
			font-weight: ${FONT_WT_LIGHT};
			line-height: 1.69;
			padding: 0px 20px 20px 20px;
			text-align: left;
		}
	}
	div {
		width: unset;
	}
	.slick-slide:nth-child(odd) > div > div > .cardWrapper {
		background-color: var(--primary-forest-600);
		color: white;
	}
	.slick-slide:nth-child(even) > div > div > .cardWrapper {
		background-color: ${COLOR_LIGHT_GREY_CYAN};
		color: ${COLOR_TEXT_PRIMARY_B2C};
	}
	.slick-slide {
		div {
			text-align: center;
			div {
				width: 300px !important;
				&:focus {
					outline: none;
				}
			}
		}
	}

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		padding: 45px 55px 70px 55px;
		.heading {
			font-size: 26px;
		}
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 70px 10px 100px 10px;
		.heading {
			font-size: 24px;
		}
		.slick-slide div div {
			max-width: 300px !important;
		}
		.cardWrapper {
			width: unset;
		}
		.slick-slide div div {
			width: unset !important;
		}
	}
`;
